import { PERSONAL_REGISTRATION_FIELDS, registrationPayload } from "./registrationPolicy";
import { squadPayload } from "./registrationSquads";

export const activeCombinedEntry = registration => ["pending", "confirmed", "checked_in"].includes(registration?.status);
export const combinedRegistrationEnabled = (page, search = "") => Boolean(page.related?.canRegisterCombined && page.related?.sideMatches?.length && new URLSearchParams(search).get("entry") !== "single");
export const combinedEntryPath = (family, matchId) => `/matches/${family}/${encodeURIComponent(matchId)}/register?entry=single`;

export function combinedRegistrationBody(personal, rows, family, revision, operationId) {
  const shared = registrationPayload(personal, family);
  return { operationId, expectedRelationshipRevision: revision,
    personal: Object.fromEntries(PERSONAL_REGISTRATION_FIELDS.map(key => [key, shared[key]])),
    selections: rows.map(row => {
      const body = registrationPayload(row.draft, family);
      for (const key of [...PERSONAL_REGISTRATION_FIELDS, "source", "discipline"]) delete body[key];
      if (family === "arc") {
        Object.assign(body, row.squad ? squadPayload(row.squad) : { squadId: "", squadNumber: null });
        body.notes = row.draft.notes?.trim() || "";
        delete body.squadScheduledAt;
      }
      return { matchId: row.match.matchId, ...body };
    }) };
}

export function combinedRequirements(rows) {
  const result = {};
  for (const row of rows) for (const [key, required] of Object.entries(row.summary?.registrationSettings?.requirements || {})) {
    if (required) result[key] = true;
  }
  return result;
}
